// extracted by mini-css-extract-plugin
export var borderRadius = "_ga-4";
export var large = "_ga-3";
export var logoContainer = "_ga-0";
export var nameLogo = "_ga-2";
export var small = "_ga-1";